import { keycloakService } from '@/services/keycloak.service'
import { config } from '@/core/config'

export const requireAuthRedirect = {
  LANDING_INVESTOR: 'LANDING_INVESTOR',
}

export default function requiredAuth({ next, to }) {
  // eslint-disable-next-line no-undef
  const { keycloak } = window
  const { meta = {} } = to

  if (meta && meta.requireAuth && (!keycloak || !keycloak.authenticated)) {
    if (meta.requireAuthRedirect) {
      switch (meta.requireAuthRedirect) {
        case requireAuthRedirect.LANDING_INVESTOR:
          location.href = config.urls.home + '/gestion-locative'
          break
      }
    } else {
      // * handles payment from offer page
      // Les landings publicitaires collectent l'email avant de renvoyer ici : on le transmet
      // a Keycloak (loginHint) pour eviter au visiteur de le ressaisir juste avant de payer.
      // Meme mecanisme que Signup.vue et la route /invitation.
      const email = to.query.email ?? null

      if (to.query.behavior === 'register') {
        keycloakService.registerAndGetBack(email)
      } else {
        keycloakService.loginAndGetBack(email)
      }
    }

    return false
  }

  return next()
}
